import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Feedback Sent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div
            style={{
              fontSize: "50px",
              color: "green",
              marginBottom: "20px",
            }}
          >
            ✔
          </div>
          <p>Thank you! Your feedback has been sent successfully.</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;
